export const SLICE_NAME = 'roleLaborTotals';
